// // frontend/src/components/PerformanceDashboard.js
// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   Container,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   Grid,
//   Avatar,
// } from "@mui/material";
// import { jwtDecode } from "jwt-decode";

// import PersonIcon from "@mui/icons-material/Person";

// const PerformanceDashboard = () => {
//   const [analytics, setAnalytics] = useState([]);
//   const [loading, setLoading] = useState(true);
//   // Retrieve role from localStorage (teacher view only)
//   const role = localStorage.getItem("role") || "student";

//   useEffect(() => {
//     const fetchAnalytics = async () => {
//       try {
//         const token = localStorage.getItem("token");
//         if (!token) {
//           console.error("No token found!");
//           return;
//         }

//         const decoded = jwtDecode(token);
//         console.log("Decoded token:", decoded);

//         const department = decoded.user.department;
//         const subjects = decoded.user.subjects || [];

//         if (!department || subjects.length === 0) {
//           console.error("Missing department or subjects for teacher");
//           return;
//         }

//         if (role === "teacher") {
//           // Fetch analytics for all students
//           const response = await axios.get(
//             `${process.env.REACT_APP_API_URL}/api/analytics/all-students-performance`
//           );

//           let filteredData = response.data;

//           // 🔥 Filter students by department & subject
//           filteredData = filteredData.filter((student) => {
//             // Match department
//             const isDeptMatch = student.department === department;

//             // Match at least one subject
//             const isSubjectMatch = student.subjects?.some((sub) =>
//               subjects.includes(sub)
//             );

//             return isDeptMatch && isSubjectMatch;
//           });

//           setAnalytics(filteredData);
//           console.log("Filtered analytics data:", filteredData);
//         } else {
//           // Optionally, handle student view if needed
//           setAnalytics([]);
//         }
//       } catch (error) {
//         console.error("Error fetching performance analytics:", error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAnalytics();
//   }, [role]);

//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         background: "linear-gradient(135deg, #f5f7fa, #c3cfe2)",
//         py: 4,
//       }}
//     >
//       <Container maxWidth="md">
//         <Box
//           sx={{
//             p: 3,
//             bgcolor: "background.paper",
//             borderRadius: 2,
//             boxShadow: 3,
//             background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
//           }}
//         >
//           <Typography
//             variant="h4"
//             gutterBottom
//             sx={{ fontWeight: "bold", color: "primary.main", mb: 2 }}
//           >
//             Performance Dashboard
//           </Typography>
//           {loading ? (
//             <Typography>Loading performance analytics...</Typography>
//           ) : analytics && analytics.length > 0 ? (
//             <Grid container spacing={2}>
//               {analytics.map((student) => (
//                 <Grid key={student._id} item xs={12} sm={6}>
//                   <Card
//                     sx={{
//                       height: "100%",
//                       display: "flex",
//                       flexDirection: "column",
//                       justifyContent: "space-between",
//                       transition: "transform 0.3s, box-shadow 0.3s",
//                       "&:hover": { transform: "scale(1.02)", boxShadow: 6 },
//                     }}
//                   >
//                     <CardContent>
//                       <Box
//                         sx={{ display: "flex", alignItems: "center", mb: 2 }}
//                       >
//                         <Avatar sx={{ bgcolor: "primary.main", mr: 2 }}>
//                           <PersonIcon />
//                         </Avatar>
//                         <Typography variant="h6">
//                           {student.username || "Unknown Student"}
//                         </Typography>
//                       </Box>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         Average Grade:{" "}
//                         {student.averageGrade !== null
//                           ? student.averageGrade.toFixed(2)
//                           : "N/A"}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         Total Graded Submissions: {student.submissionsCount}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         Study Streak: {student.studyStreak}
//                       </Typography>
//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         Subjects:{" "}
//                         {student.subjects && student.subjects.length > 0
//                           ? student.subjects.join(", ")
//                           : "N/A"}
//                       </Typography>

//                       <Typography variant="body2" sx={{ mb: 1 }}>
//                         Department:{" "}
//                         {student.department !== null
//                           ? student.department
//                           : "N/A"}
//                       </Typography>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               ))}
//             </Grid>
//           ) : (
//             <Typography>No student performance data available.</Typography>
//           )}
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default PerformanceDashboard;

import React, { useState, useEffect } from "react";
import axios from "axios";
import { jwtDecode } from "jwt-decode";

const PerformanceDashboard = () => {
  const [analytics, setAnalytics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortBy, setSortBy] = useState("averageGrade");
  const [sortOrder, setSortOrder] = useState("desc");

  // Retrieve role from localStorage (teacher view only)
  const role = localStorage.getItem("role") || "student";
  const username = localStorage.getItem("username");
  const department = localStorage.getItem("department");

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found!");
          return;
        }

        const decoded = jwtDecode(token);
        console.log("Decoded token:", decoded);

        const department = decoded.user.department;
        const subjects = decoded.user.subjects || [];

        if (!(username === "admin") && (!department || subjects.length === 0)) {
          console.error("Missing department or subjects for teacher");
          return;
        }

        if (role === "teacher" || username === "admin") {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/analytics/all-students-performance`
          );

          let filteredData = response.data;

          filteredData = filteredData.filter((student) => {
            const isDeptMatch = student.department === department;

            if (username === "admin") {
              return isDeptMatch;
            }
            else if (!(username === "admin")) {
              const isSubjectMatch = student.subjects?.some((sub) =>
                subjects.includes(sub)
              );
              return isDeptMatch && isSubjectMatch;
            }
          });

          setAnalytics(filteredData);
          console.log(
            `Filtered analytics data (${role === "teacher" ? "Teacher" : "Admin"}):`,
            filteredData
          );
        }
        else {
          // Optionally, handle student view if needed
          setAnalytics([]);
        }
      } catch (error) {
        console.error("Error fetching performance analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, [role]);

  // Filter and sort analytics
  const filteredAnalytics = analytics
    .filter(student =>
      student.username?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.department?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      student.subjects?.some(sub => sub.toLowerCase().includes(searchTerm.toLowerCase()))
    )
    .sort((a, b) => {
      let aVal = a[sortBy];
      let bVal = b[sortBy];

      // Handle null/undefined values
      if (aVal === null || aVal === undefined) aVal = sortBy === 'averageGrade' ? 0 : '';
      if (bVal === null || bVal === undefined) bVal = sortBy === 'averageGrade' ? 0 : '';

      if (sortOrder === 'asc') {
        return aVal > bVal ? 1 : -1;
      } else {
        return aVal < bVal ? 1 : -1;
      }
    });

  const getGradeColor = (grade) => {
    if (grade >= 90) return 'linear-gradient(45deg, #10b981, #059669)';
    if (grade >= 80) return 'linear-gradient(45deg, #3b82f6, #1d4ed8)';
    if (grade >= 70) return 'linear-gradient(45deg, #f59e0b, #d97706)';
    if (grade >= 60) return 'linear-gradient(45deg, #ef4444, #dc2626)';
    return 'linear-gradient(45deg, #6b7280, #4b5563)';
  };

  const getPerformanceIcon = (grade) => {
    if (grade >= 90) return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
      </svg>
    );
    if (grade >= 80) return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M9,11H7L12,6L17,11H15V16H9V11M5,20V18H19V20H5Z" />
      </svg>
    );
    if (grade >= 70) return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4Z" />
      </svg>
    );
    return (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M11,16.5L6.5,12L7.91,10.59L11,13.67L16.59,8.09L18,9.5L11,16.5Z" />
      </svg>
    );
  };

  const getStreakIcon = (streak) => {
    if (streak >= 30) return '🔥';
    if (streak >= 14) return '⚡';
    if (streak >= 7) return '✨';
    return '💫';
  };

  const calculateStats = () => {
    if (filteredAnalytics.length === 0) return { avgGrade: 0, totalStudents: 0, highPerformers: 0 };

    const avgGrade = filteredAnalytics.reduce((sum, student) =>
      sum + (student.averageGrade || 0), 0) / filteredAnalytics.length;

    const highPerformers = filteredAnalytics.filter(student =>
      (student.averageGrade || 0) >= 80).length;

    return {
      avgGrade: avgGrade.toFixed(1),
      totalStudents: filteredAnalytics.length,
      highPerformers
    };
  };

  const stats = calculateStats();

  return (
    <div className="performance-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .performance-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .performance-container::before {
          content: '';
          position: absolute;
          top: 10%;
          right: 15%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 6s ease-in-out infinite;
        }

        .performance-container::after {
          content: '';
          position: absolute;
          bottom: 20%;
          left: 8%;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.06);
          animation: float 4s ease-in-out infinite reverse;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(15deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes cardSlide {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .pulse-element {
          position: absolute;
          top: 30%;
          right: 25%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          animation: pulse 3s ease-in-out infinite;
        }

        .performance-wrapper {
          max-width: 1200px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .header-section {
          text-align: center;
          margin-bottom: 3rem;
        }

        .header-chip {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(255, 255, 255, 0.15);
          color: white;
          padding: 0.5rem 1.2rem;
          border-radius: 50px;
          font-size: 0.9rem;
          font-weight: 500;
          margin-bottom: 1.5rem;
          backdrop-filter: blur(15px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .main-title {
          font-size: clamp(2.5rem, 5vw, 3.5rem);
          font-weight: 900;
          color: white;
          margin-bottom: 0.5rem;
          text-shadow: 0 4px 20px rgba(0,0,0,0.3);
          animation: slideIn 0.8s ease-out;
        }

        .gradient-text {
          background: linear-gradient(45deg, #FFD700, #FF6B6B, #4ECDC4);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .subtitle {
          color: rgba(255, 255, 255, 0.9);
          font-weight: 300;
          font-size: 1.1rem;
          animation: slideIn 0.8s ease-out 0.2s both;
        }

        .stats-section {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin-bottom: 3rem;
        }

        .stat-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 2rem;
          text-align: center;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          animation: slideIn 0.6s ease-out;
          position: relative;
          overflow: hidden;
        }

        .stat-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        }

        .stat-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2);
          border-radius: 20px 20px 0 0;
        }

        .stat-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          margin: 0 auto 1rem;
          box-shadow: 0 8px 20px rgba(102, 126, 234, 0.3);
        }

        .stat-value {
          font-size: 2.2rem;
          font-weight: 800;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .stat-label {
          color: #6b7280;
          font-weight: 500;
          font-size: 1rem;
        }

        .controls-section {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 20px;
          padding: 2rem;
          margin-bottom: 2rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          animation: slideIn 0.8s ease-out 0.4s both;
        }

        .controls-grid {
          display: grid;
          grid-template-columns: 1fr auto auto;
          gap: 1.5rem;
          align-items: center;
        }

        .search-container {
          position: relative;
        }

        .search-input {
          width: 100%;
          padding: 1rem 1rem 1rem 3rem;
          border: 2px solid rgba(102, 126, 234, 0.1);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          box-sizing: border-box;
        }

        .search-input:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .search-icon {
          position: absolute;
          left: 1rem;
          top: 50%;
          transform: translateY(-50%);
          color: #6b7280;
          pointer-events: none;
        }

        .sort-container {
          display: flex;
          gap: 0.75rem;
          align-items: center;
        }

        .sort-select {
          padding: 1rem;
          border: 2px solid rgba(102, 126, 234, 0.1);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          cursor: pointer;
          outline: none;
          min-width: 150px;
        }

        .sort-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
        }

        .sort-order-btn {
          padding: 1rem;
          background: rgba(102, 126, 234, 0.1);
          border: 2px solid rgba(102, 126, 234, 0.1);
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          color: #667eea;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .sort-order-btn:hover {
          background: rgba(102, 126, 234, 0.2);
        }

        .students-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
          gap: 1.5rem;
        }

        .student-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 18px;
          padding: 2rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          animation: cardSlide 0.5s ease-out;
          position: relative;
          overflow: hidden;
        }

        .student-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 25px 50px rgba(0,0,0,0.15);
        }

        .student-header {
          display: flex;
          align-items: center;
          margin-bottom: 1.5rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid rgba(0,0,0,0.05);
        }

        .student-avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: linear-gradient(45deg, #667eea 30%, #764ba2 90%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          font-weight: 600;
          margin-right: 1rem;
          flex-shrink: 0;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }

        .student-info {
          flex: 1;
        }

        .student-name {
          font-size: 1.3rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 0.25rem;
        }

        .student-department {
          color: #6b7280;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .grade-badge {
          position: absolute;
          top: 1.5rem;
          right: 1.5rem;
          padding: 0.5rem 1rem;
          border-radius: 25px;
          color: white;
          font-weight: 700;
          font-size: 0.9rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          box-shadow: 0 4px 12px rgba(0,0,0,0.2);
        }

        .metrics-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .metric-item {
          background: rgba(102, 126, 234, 0.05);
          padding: 1rem;
          border-radius: 12px;
          text-align: center;
          border: 1px solid rgba(102, 126, 234, 0.1);
        }

        .metric-value {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
          margin-bottom: 0.25rem;
        }

        .metric-label {
          color: #6b7280;
          font-size: 0.85rem;
          font-weight: 500;
        }

        .subjects-section {
          margin-top: 1rem;
        }

        .subjects-label {
          font-size: 0.9rem;
          font-weight: 600;
          color: #374151;
          margin-bottom: 0.75rem;
        }

        .subjects-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
        }

        .subject-tag {
          background: rgba(16, 185, 129, 0.1);
          color: #059669;
          padding: 0.4rem 0.8rem;
          border-radius: 20px;
          font-size: 0.8rem;
          font-weight: 500;
          border: 1px solid rgba(16, 185, 129, 0.2);
        }

        .loading-container {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 4rem;
        }

        .loading-content {
          text-align: center;
          color: white;
        }

        .loading-spinner {
          width: 50px;
          height: 50px;
          border: 4px solid rgba(255, 255, 255, 0.3);
          border-top: 4px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
          margin: 0 auto 1.5rem;
        }

        .empty-state {
          text-align: center;
          padding: 4rem 2rem;
          background: rgba(255, 255, 255, 0.1);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .empty-icon {
          width: 100px;
          height: 100px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 2rem;
          color: white;
          font-size: 2.5rem;
        }

        .empty-title {
          font-size: 1.8rem;
          font-weight: 700;
          color: white;
          margin-bottom: 1rem;
        }

        .empty-description {
          color: rgba(255, 255, 255, 0.8);
          font-size: 1.1rem;
          line-height: 1.6;
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .performance-container {
            padding: 1rem 0.5rem;
          }
          
          .students-grid {
            grid-template-columns: 1fr;
            gap: 1.5rem;
          }
          
          .controls-grid {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
          
          .sort-container {
            justify-content: space-between;
          }
          
          .stats-section {
            grid-template-columns: 1fr;
            gap: 1rem;
          }
          
          .student-card {
            padding: 1.5rem;
          }
          
          .grade-badge {
            position: static;
            margin-top: 1rem;
            align-self: flex-start;
          }
          
          .student-header {
            flex-wrap: wrap;
          }

          .metrics-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      <div className="pulse-element"></div>

      <div className="performance-wrapper">
        {/* Header Section */}
        <div className="header-section">
          <div className="header-chip">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16,11.78L20.24,4.45L21.97,5.45L16.74,14.5L10.23,10.75L5.46,19H22V21H2V3H4V17.54L9.5,8L16,11.78Z" />
            </svg>
            Student Analytics
          </div>

          <h1 className="main-title">
            <span className="gradient-text">Performance</span> Dashboard
          </h1>

          <p className="subtitle">
            Monitor student progress and academic achievements
          </p>
        </div>

        {/* Stats Section */}
        {!loading && analytics.length > 0 && (
          <div className="stats-section">
            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,6A6,6 0 0,1 18,12A6,6 0 0,1 12,18A6,6 0 0,1 6,12A6,6 0 0,1 12,6M12,8A4,4 0 0,0 8,12A4,4 0 0,0 12,16A4,4 0 0,0 16,12A4,4 0 0,0 12,8Z" />
                </svg>
              </div>
              <div className="stat-value">{stats.avgGrade}</div>
              <div className="stat-label">Average Grade</div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16,4C18.11,4 20,5.89 20,8A4,4 0 0,1 16,12A4,4 0 0,1 12,8A4,4 0 0,1 16,4M16,6A2,2 0 0,0 14,8A2,2 0 0,0 16,10A2,2 0 0,0 18,8A2,2 0 0,0 16,6M16,13C18.67,13 22,14.33 22,17V20H10V17C10,14.33 13.33,13 16,13M8,12A4,4 0 0,1 4,8A4,4 0 0,1 8,4A4,4 0 0,1 12,8A4,4 0 0,1 8,12M8,13C5.67,13 1,14.17 1,16.5V19H9V16.88C9.86,16.46 11.31,15.91 14.14,15.91C14.39,15.91 14.65,15.92 14.92,15.94C13.93,13.83 11.73,13 8,13Z" />
                </svg>
              </div>
              <div className="stat-value">{stats.totalStudents}</div>
              <div className="stat-label">Total Students</div>
            </div>

            <div className="stat-card">
              <div className="stat-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" />
                </svg>
              </div>
              <div className="stat-value">{stats.highPerformers}</div>
              <div className="stat-label">High Performers (80+)</div>
            </div>
          </div>
        )}

        {/* Controls Section */}
        {!loading && analytics.length > 0 && (
          <div className="controls-section">
            <div className="controls-grid">
              <div className="search-container">
                <div className="search-icon">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" />
                  </svg>
                </div>
                <input
                  type="text"
                  className="search-input"
                  placeholder="Search students, departments, or subjects..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              <select
                className="sort-select"
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="averageGrade">Average Grade</option>
                <option value="username">Name</option>
                <option value="submissionsCount">Submissions</option>
                <option value="studyStreak">Study Streak</option>
              </select>

              <button
                className="sort-order-btn"
                onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}
                title={`Sort ${sortOrder === 'asc' ? 'Descending' : 'Ascending'}`}
              >
                {sortOrder === 'asc' ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19,17H22L18,21L14,17H17V3H19V17M2,17H12V19H2V17M6,5V7H2V5H6M2,11V13H9V11H2Z" />
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19,7H22L18,3L14,7H17V21H19V7M2,17H12V19H2V17M6,5V7H2V5H6M2,11V13H9V11H2Z" />
                  </svg>
                )}
              </button>
            </div>
          </div>
        )}

        {/* Main Content */}
        {loading ? (
          <div className="loading-container">
            <div className="loading-content">
              <div className="loading-spinner"></div>
              <h3 style={{ marginBottom: '0.5rem', fontSize: '1.3rem', fontWeight: '600' }}>
                Loading Performance Data
              </h3>
              <p>Analyzing student performance metrics...</p>
            </div>
          </div>
        ) : filteredAnalytics.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">
              📊
            </div>
            <h3 className="empty-title">No Performance Data Available</h3>
            <p className="empty-description">
              {searchTerm ?
                `No students found matching "${searchTerm}". Try adjusting your search criteria.` :
                'There are currently no student performance records to display. Students will appear here once they start submitting assignments.'
              }
            </p>
          </div>
        ) : (
          <div className="students-grid">
            {filteredAnalytics.map((student, index) => (
              <div
                key={student._id}
                className="student-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="student-header">
                  <div className="student-avatar">
                    {student.username ? student.username.charAt(0).toUpperCase() : '?'}
                  </div>
                  <div className="student-info">
                    <div className="student-name">
                      {student.username || 'Unknown Student'}
                    </div>
                    <div className="student-department">
                      {student.department || 'No Department'}
                    </div>
                  </div>
                </div>

                <div
                  className="grade-badge"
                  style={{ background: getGradeColor(student.averageGrade || 0) }}
                >
                  {getPerformanceIcon(student.averageGrade || 0)}
                  {student.averageGrade !== null ? student.averageGrade.toFixed(1) : 'N/A'}
                </div>

                <div className="metrics-grid">
                  <div className="metric-item">
                    <div className="metric-value">
                      {student.submissionsCount || 0}
                    </div>
                    <div className="metric-label">Submissions</div>
                  </div>

                  <div className="metric-item">
                    <div className="metric-value">
                      {getStreakIcon(student.studyStreak || 0)} {student.studyStreak || 0}
                    </div>
                    <div className="metric-label">Study Streak</div>
                  </div>
                </div>

                {student.subjects && student.subjects.length > 0 && (
                  <div className="subjects-section">
                    <div className="subjects-label">Subjects</div>
                    <div className="subjects-list">
                      {student.subjects.map((subject, idx) => (
                        <span key={idx} className="subject-tag">
                          {subject}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PerformanceDashboard;